export let orderBy = "";
export var columns = [
	{
		title: '序号',
		customRender: (text, record, index) => {
			return index + 1;
		},
		width: 50,
		align: 'center'
	},
	{
		title: "部门编码",
		dataIndex: "dept_code",
		align: "center",
		width: 90,
	},
	{
		title: "部门名称",
		dataIndex: "dept_name",
		align: "center",
		ellipsis: true,
		width: 210,
	},
	{
		title: "上级部门名称",
		dataIndex: "sjname",
		align: "center",
		width: 210,
	},
	{
		title: "组织类型",
		dataIndex: "dept_glbdef3_desc",
		width: 150,
		align: "center",
		// scopedSlots: { customRender: 'letter_type' },
		ellipsis: true,
	},
	{
		title: "部门简称",
		dataIndex: "shortname",
		// scopedSlots: { customRender: 'content' },
		align: "center",
		width: 210,
		ellipsis: true,
	},
	{
		title: "部门领导人力编码",
		dataIndex: "principal",
		align: "center",
		ellipsis: true,
		// sorter: ()=>{},
		width: 110,
	},
	{
		title: "创建时间",
		dataIndex: "create_time",
		align: "center",
		ellipsis: true,
		width: 130,
	},
	{
		title: "上级机构内排序",
		dataIndex: "display_order",
		align: "center",
		// sorter: ()=>{},
		width: 100,
	},
	{
		title: "操作",
		dataIndex: 'operation',
		scopedSlots: { customRender: 'operation' },
		align: "center",
		width: 150,
	},
];
